import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { EASY_MASSAGE_URL } from "@/lib/assets";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Industries", to: "/industries" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${
                  isActive ? "text-[#3EA65B]" : "text-gray-600 hover:text-[#0A0A0A]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <a
          href={EASY_MASSAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white px-6 py-2.5 text-sm font-semibold hover:bg-gray-800 transition-all"
        >
          Visit Easy Massage <ArrowUpRight className="h-4 w-4" />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#0A0A0A]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `block text-base font-semibold py-1.5 ${
                  isActive ? "text-[#3EA65B]" : "text-gray-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={EASY_MASSAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-header-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white px-6 py-2.5 text-sm font-semibold mt-2"
          >
            Visit Easy Massage <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
